'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _reactRouterRedux = require('react-router-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackButton = (_dec = (0, _reactRedux.connect)(null, { goBack: _reactRouterRedux.goBack, push: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BackButton, _Component);

  function BackButton() {
    (0, _classCallCheck3.default)(this, BackButton);
    return (0, _possibleConstructorReturn3.default)(this, (BackButton.__proto__ || (0, _getPrototypeOf2.default)(BackButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(BackButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          asBlock = _props.asBlock,
          className = _props.className,
          blockClassName = _props.blockClassName,
          backUrl = _props.backUrl;

      var buttonClass = (0, _bind2.default)(className, 'btn', 'btn-stroke', 'small');

      var button = _react2.default.createElement(
        'button',
        { className: buttonClass, onClick: function onClick() {
            return backUrl ? _this2.props.push(backUrl) : _this2.props.goBack();
          } },
        _react2.default.createElement('i', { className: 'icon-back' }),
        _react2.default.createElement(
          'span',
          { className: 'margin-left-10' },
          t('Back')
        )
      );

      return asBlock ? _react2.default.createElement(
        'div',
        { className: blockClassName },
        button
      ) : button;
    }
  }]);
  return BackButton;
}(_react.Component), _class2.propTypes = {
  asBlock: _propTypes2.default.bool,
  backUrl: _propTypes2.default.string,
  blockClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  goBack: _propTypes2.default.func,
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = BackButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BackButton/BackButton.js
// module id = 256
// module chunks = 1